import DeleteIcon from "../../images/icon_delete.svg";
import PDFIcon from "../../images/icon_pdf.svg";
import UploadIcon from "../../images/icon_upload_file.svg";
import { FILE_FORMATS } from "../../utils/constants";
import FileDropArea from "../FileDropArea/FileDropArea";
import {
  DashedRow,
  FileInfo,
  RowContainer,
} from "./UsersManagementAdminStyles";
const FileUploadInputDirect = (props) => {
  const { onValueChange, value, maxFiles, formats, width, height } = props;
  const appendFiles = (newFiles) => {
    onValueChange([...value, ...newFiles].slice(0, maxFiles || 1));
  };

  const removeFile = (deleteIdx) => {
    onValueChange(value.filter((_, idx) => idx !== deleteIdx));
  };

  const formatSize = (bytes) => {
    if (bytes < 1000000) return Math.max(Math.round(bytes / 1000), 1) + " KB";
    if (bytes < 1000000000)
      return Math.round((bytes / (1000 * 1000)) * 10) / 10 + " MB";
    return "More than 1GB";
  };

  const extensions = formats.flat().map((format) => {
    return typeof format === "object" ? format.extension : format;
  });
  const accepts = formats.flat().map((format) => {
    return typeof format === "object" ? format.accept : format;
  });

  return (
    <>
      {value.map((file, idx) => {
        return (
          <FileInfo key={idx}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "25rem",
                justifyContent: "space-between",
              }}
            >
              <div>
                <img src={PDFIcon} alt="PDFIcon" />
              </div>
              <div>
                <p>
                  {file.name.substring(file.name.length - 14, file.name.length)}
                </p>
              </div>
              <div>
                <p className="size">{formatSize(file.size)}</p>
              </div>
              <div>
                <img
                  style={{ cursor: "pointer" }}
                  className="delete-icon"
                  src={DeleteIcon}
                  alt="DeleteIcon"
                  onClick={() => removeFile(idx)}
                />
              </div>
            </div>
          </FileInfo>
        );
      })}
      {value.length < maxFiles && (
        <RowContainer width={width} height={height}>
          <FileDropArea
            onDrop={appendFiles}
            formats={accepts || [FILE_FORMATS.PDF, FILE_FORMATS.IMAGE]}
            validExtensions={extensions}
          >
            <DashedRow>
              <img src={UploadIcon} alt="UploadIcon" />
              <div>{`Toca para subir un documento`}</div>
            </DashedRow>
          </FileDropArea>
        </RowContainer>
      )}
    </>
  );
};

export default FileUploadInputDirect;
